import { useApi } from "hooks"
import { useMutation } from "@tanstack/react-query"
import { GAHandler } from "utils/GA"
import { RECAPTCHA_TYPES } from "config/constants"

const useLogin = () => {

  const { apiFetch } = useApi()

  const url = `/auth/login`;

  const login = ({ email, password }) => {
    return apiFetch({
      url,
      method: 'POST',
      data: {
        email,
        password
      },
      captcha: {
        type: RECAPTCHA_TYPES.v3,
        action: 'login'
      }
    })
    .then( resLogin => {
      GAHandler('login_flixxo');
      return resLogin.data
    })
    .catch((err) => {
      GAHandler('login_flixxo_error');
      throw err
    })
  }

  const {
    mutate,
    ...rest
  } = useMutation(login)

  return {
    login: mutate,
    ...rest
  }

}

export default useLogin
